import { initMessageLoader } from "./initMessageLoader";

// ── Helpers ──────────────────────────────────────────────────────

function getChatRoot(chatForm) {
  return chatForm.hasClass("g-chatform")
    ? chatForm
    : chatForm.closest(".g-chatform");
}

function getContentWrapper(chatForm) {
  return chatForm.hasClass("g-chatform-content")
    ? chatForm
    : chatForm.find(".g-chatform-content");
}

function resetUserMessageTemplate(template) {
  template.removeClass("g-chatform-message-generating is-pending-response");
  template.find(".g-chatform-message-inner").hide();
  template.find(".g-chatform-message-content-inner").hide().empty();
  template.find(".g-chatform-message-actions").hide();
  template.find(".g-chatform-message-time").empty();
  template.attr("data-id", "");
}

export function ensureContentGeneratingLoader(container) {
  let loader = container.find(".g-chatform-content-generating-loader");
  if (!loader.length) {
    const chatRoot = container.hasClass("g-chatform")
      ? container
      : container.closest(".g-chatform");
    const chatId = chatRoot.attr("id");
    const loaderHtml =
      window.growtype_chat?.[chatId]?.content_generating_loader;
    if (loaderHtml) {
      loader = jQuery(loaderHtml);
      container.append(loader);
    }
  }
  return loader;
}

function setupMessageLoader(template, category, chatRoot) {
  // Always hide the generating loader first
  ensureContentGeneratingLoader(template).addClass("d-none");

  if (["image", "video"].includes(category)) {
    // Circular spinner + progress bar for visual generation
    template.addClass("g-chatform-message-generating");
    ensureContentGeneratingLoader(template).removeClass("d-none");
  } else {
    // Dots loader with avatar + typing/generating text (text / audio)
    initMessageLoader(template, chatRoot, category);
  }
}

// ── Public ───────────────────────────────────────────────────────

export function appendUserMessage(chatForm, category = null, options = {}) {
  const chatRoot = getChatRoot(chatForm);
  const contentWrapper = getContentWrapper(chatForm);
  const chatFormInput = chatRoot.find(".g-chatform-text-input");

  if (!category) {
    category = chatFormInput.attr("data-category") ?? "text";
  }

  const reusesTemplates =
    options.reusePending !== false &&
    !["image", "video", "audio"].includes(category);
  let template = $([]);

  if (reusesTemplates) {
    const pending = contentWrapper.find(
      '.g-chatform-message[data-role="user"].is-pending-response'
    );
    template = pending.last();
    if (pending.length > 1) {
      pending.not(template).remove();
    }
  }

  if (!template.length) {
    template = chatRoot
      .find('.g-chatform-message[data-role="user"]')
      .first()
      .clone();
    contentWrapper.append(template);
  } else {
    template.detach();
    contentWrapper.append(template);
  }

  resetUserMessageTemplate(template);
  setupMessageLoader(template, category, chatRoot);
  template.hide(); // shown later by caller when appropriate

  return template;
}
